module.exports = __webpack_public_path__ + "static/img/error.06c9529.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.png
// module id = 3xxH
// module chunks = 1